import { jsx as _jsx } from "react/jsx-runtime";
import { useRecoilValueLoadable } from 'recoil';
// tslint:disable-next-line: function-name
export default function EvaStateLoader({ recoilState, }) {
    // We just need to require it to ensure it is alive
    // Using loadable to prevent suspense issues
    //
    useRecoilValueLoadable(recoilState);
    return (_jsx("div", {}));
}
//# sourceMappingURL=eva-state-loader.js.map